import store from '@/store'
import { getStudentInfo } from '@/api/live'

/*
token
studentInfo
userInfo
*/
export default async function(token) {
  if (!token) {
    return false
  }

  // 1. 设置 url 传来的 token
  localStorage.setItem('token', token)

  // 2. 设置学员信息
  const studentInfo = await getStudentInfo({})
  if (!studentInfo) {
    return false
  }
  localStorage.setItem('studentInfo', JSON.stringify(studentInfo))
  store.commit('setStudentInfo', studentInfo)

  // 3. 设置用户信息
  // const resultByAccessToken = await getInfoByAccessToken({
  //   access_token: token,
  //   openid: studentInfo.openid
  // })

  // localStorage.setItem('userInfo', JSON.stringify(resultByAccessToken))
  // store.commit('setUserInfo', resultByAccessToken)
}
